import {
  Component,
  Input,
  ViewChild,
  OnInit,
  ViewContainerRef,
  ViewEncapsulation,
  OnDestroy,
  AfterViewInit,
  ElementRef,
} from "@angular/core";
import { SubSink } from "subsink";

import { Configuration, BigNumberDatasource } from "@/shared-module/models";
import { ZoneComponent } from "@/shared-module/components";
import { ConfigurationService } from "@/shared-module/services";
import { DialogService } from "@/shared-module/services";

@Component({
  selector: "app-bignumber",
  templateUrl: "bignumber.component.html",
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .popover-1 {
        padding: 32px;
        color: #9797b3;
      }
      .popover-1 body {
        color: #9797b3;
      }
      .popover-1 body b {
        color: #00001f;
      }
      .popover-1 .btn {
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 2px;
        padding: 12px 24px;
        color: #ffffff;
      }
    `,
  ],
})
export class BigNumberComponent implements OnInit, AfterViewInit, ZoneComponent, OnDestroy {
  @Input() data: BigNumberDatasource;
  @Input() width: number;
  @Input() needpaddingLeft: boolean;
  @Input() isZoom: boolean;
  @ViewChild("template", { static: true }) template;
  @ViewChild("value1", { read: ElementRef }) value1: ElementRef;
  @ViewChild("value2", { read: ElementRef }) value2: ElementRef;
  @ViewChild("title1", { read: ElementRef }) title1: ElementRef;
  @ViewChild("title2", { read: ElementRef }) title2: ElementRef;
  subs = new SubSink();
  highContrast: boolean;
  reduceSize = false;
  alignTitleHeight = false;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private configurationService: ConfigurationService,
    private dialogService: DialogService
  ) {
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        this.highContrast = c.highContrast;
      },
    );
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
  }

  ngAfterViewInit() {
    // Check if text wraps to multiple lines
    setTimeout(() => {
      this.checkAndAdjustFontSize();
    }, 0);
  }

  private checkAndAdjustFontSize() {
    // Check if either value wraps - if so, reduce both for consistency
    const value1Wrapped = this.value1?.nativeElement ? this.isTextWrapped(this.value1.nativeElement) : false;
    const value2Wrapped = this.value2?.nativeElement ? this.isTextWrapped(this.value2.nativeElement) : false;

    this.reduceSize = value1Wrapped || value2Wrapped;

    // Check if either title wraps - if so, align both heights
    const title1Wrapped = this.title1?.nativeElement ? this.isTextWrapped(this.title1.nativeElement) : false;
    const title2Wrapped = this.title2?.nativeElement ? this.isTextWrapped(this.title2.nativeElement) : false;

    this.alignTitleHeight = title1Wrapped || title2Wrapped;
  }

  private isTextWrapped(element: HTMLElement): boolean {
    const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
    const height = element.offsetHeight;
    // If height is more than 1.5 times the line height, text has wrapped
    return height > lineHeight * 1.5;
  }

  zoom(zoomInfo?: any) {
    this.dialogService.setZoomInfo(zoomInfo);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
